import {inject} from '@angular/core';
import {Router, UrlTree} from '@angular/router';
import {PermissionsService} from '@q9elements/ui-kit/common';

import {ROUTES_PATH} from '../models/routes-path.enum';

type LicenseChecker = (permissionsService: PermissionsService) => boolean;

export const LicenseGuard =
  (licenseChecker: LicenseChecker, redirectPath: string = ROUTES_PATH.DASHBOARD) =>
  (): boolean | UrlTree => {
    const permissionsService = inject(PermissionsService);
    const router = inject(Router);

    if (licenseChecker(permissionsService)) {
      return true;
    }

    return router.createUrlTree([redirectPath]);
  };
